/* Fellhold extras: review slider, product videos, photo-review arrows, dispatch cut-off countdown */
(function(){
  "use strict";
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- small review slider ---- */
  $$("[data-fh-rs]").forEach(function(el){
    var items = $$(".rs-item", el), dots = $$(".rs-dots i", el), i = 0, t = null;
    if (!items.length) return;
    el.setAttribute("data-ready", "");
    function show(n){
      i = (n + items.length) % items.length;
      items.forEach(function(x, k){ x.classList.toggle("on", k === i); x.setAttribute("aria-hidden", k === i ? "false" : "true"); });
      dots.forEach(function(x, k){ x.classList.toggle("on", k === i); });
    }
    function play(){ stop(); if (items.length > 1 && !reduce) t = setInterval(function(){ show(i + 1); }, 5000); }
    function stop(){ if (t) clearInterval(t); t = null; }
    $$(".rs-ar", el).forEach(function(b){ b.addEventListener("click", function(){ show(i + Number(b.dataset.dir)); play(); }); });
    el.addEventListener("mouseenter", stop); el.addEventListener("mouseleave", play);
    el.addEventListener("focusin", stop); el.addEventListener("focusout", play);
    show(0); play();
  });

  /* ---- product videos: tap to play, one at a time ---- */
  $$("[data-fh-vids]").forEach(function(row){
    var cells = $$(".v", row);
    cells.forEach(function(c){
      var v = c.querySelector("video"); if (!v) return;
      v.removeAttribute("controls"); v.removeAttribute("autoplay");
      v.addEventListener("play", function(){ c.classList.add("playing"); });
      v.addEventListener("pause", function(){ c.classList.remove("playing"); });
      c.setAttribute("role", "button"); c.setAttribute("tabindex", "0");
      c.setAttribute("aria-label", "Play video" + (c.querySelector(".c") ? ": " + c.querySelector(".c").textContent : ""));
      function toggle(){
        if (v.paused){
          cells.forEach(function(o){ var ov = o.querySelector("video"); if (ov && ov !== v) ov.pause(); });
          v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function(){ v.muted = true; v.play(); });
        } else v.pause();
      }
      c.addEventListener("click", toggle);
      c.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " "){ e.preventDefault(); toggle(); } });
    });
  });

  /* ---- photo reviews arrows ---- */
  $$("[data-fh-prs]").forEach(function(track){
    var nav = track.parentNode.querySelector(".prs-nav"); if (!nav) return;
    $$("button", nav).forEach(function(b){
      b.addEventListener("click", function(){
        var card = track.querySelector(".prc"); var step = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
        track.scrollBy({ left: step * Number(b.dataset.dir), behavior: reduce ? "auto" : "smooth" });
      });
    });
    function sync(){ nav.hidden = track.scrollWidth <= track.clientWidth + 4; }
    sync(); window.addEventListener("resize", sync);
  });

  /* ---- dispatch cut-off countdown (US Eastern, weekdays) ---- */
  var cut = document.getElementById("fhCut");
  var C = window.FH_CONFIG || {};
  function etParts(){
    var f = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", weekday: "short", hour: "numeric", minute: "numeric", hourCycle: "h23" });
    var o = {}; f.formatToParts(new Date()).forEach(function(p){ o[p.type] = p.value; });
    return { day: o.weekday, h: Number(o.hour), m: Number(o.minute) };
  }
  function addBiz(d, n){ var x = new Date(d); while (n > 0){ x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; }
  function g(d){ return d.toLocaleDateString("en-US", { month: "short", day: "numeric" }); }
  function tick(){
    if (!cut) return;
    var hour = Number(cut.dataset.hour) || 14, p = etParts();
    var weekday = ["Sat", "Sun"].indexOf(p.day) === -1;
    var left = hour * 60 - (p.h * 60 + p.m);
    var before = weekday && left > 0;
    if (before){
      var hh = Math.floor(left / 60), mm = left % 60;
      cut.innerHTML = "Order in the next <b>" + (hh ? hh + " hr" + (hh > 1 ? "s " : " ") : "") + mm + " min</b> for these dates";
      cut.hidden = false;
    } else cut.hidden = true;
    /* past today's cut-off (or weekend): the order waits for the next dispatch day */
    var dd = (C.dispatchDays || []).map(Number), td = (C.transitDays || []).map(Number);
    if (dd.length < 2 || td.length < 2 || dd.some(isNaN) || td.some(isNaN)) return;
    var base = before ? new Date() : addBiz(new Date(), 1);
    var sa = addBiz(base, dd[0]), sb = addBiz(base, dd[1]);
    var s = document.getElementById("etaShip"), l = document.getElementById("etaLine");
    if (s) s.textContent = g(sa) + " – " + g(sb);
    if (l) l.textContent = g(addBiz(sa, td[0])) + " – " + g(addBiz(sb, td[1]));
  }
  if (cut){ tick(); setTimeout(tick, 0); window.addEventListener("load", tick); setInterval(tick, 30000); }
})();
